module.exports = __webpack_public_path__ + "static/media/background-1.c7838262.jpg";